/**
 * Dev-only logger.
 *
 * Verbose diagnostics (console.log/debug noise) route through `devLog` so they
 * appear during `vite dev` but are silenced in production builds.
 * console.warn / console.error stay untouched everywhere — real problems must
 * always surface.
 */
export const devLog: (...args: unknown[]) => void = import.meta.env.DEV
  ? console.log.bind(console)
  : () => undefined;
